import { useState } from "react";
import { Card, Divider, List, Text } from "react-native-paper";
import { useAppTheme } from "../../../../useAppTheme";
import Box from "../../../Box";

const EXAMPLE_DOT_SIZE = 4;

export type ToeicLevelDetail = {
	id: string;
	name: string;
	scoreRange: string;
	summary: string;
	examples: string[];
};

type Props = {
	title: string;
	levels: ToeicLevelDetail[];
};

const LevelDetailBlock = ({ level }: { level: ToeicLevelDetail }) => {
	const theme = useAppTheme();

	return (
		<Box paddingHorizontal={16} paddingVertical={12} gap={4}>
			<Box
				flexDirection="row"
				alignItems="center"
				justifyContent="space-between"
				gap={8}
			>
				<Text variant="labelLarge">{level.name}</Text>
				<Text
					variant="bodySmall"
					style={{ color: theme.colors.onSurfaceVariant }}
				>
					{level.scoreRange}
				</Text>
			</Box>
			<Text
				variant="bodySmall"
				style={{
					color: theme.colors.onSurfaceVariant,
					fontStyle: "italic",
				}}
			>
				{level.summary}
			</Text>
			<Box gap={4} paddingTop={4}>
				{level.examples.map((example) => (
					<Box
						key={example}
						flexDirection="row"
						alignItems="center"
						gap={8}
						paddingLeft={4}
					>
						<Box
							width={EXAMPLE_DOT_SIZE}
							height={EXAMPLE_DOT_SIZE}
							borderRadius={EXAMPLE_DOT_SIZE / 2}
							backgroundColor={theme.colors.primary}
						/>
						<Text variant="bodySmall">{example}</Text>
					</Box>
				))}
			</Box>
		</Box>
	);
};

export const ToeicLevelDetailsAccordion = ({ title, levels }: Props) => {
	const theme = useAppTheme();
	const [expanded, setExpanded] = useState(false);

	return (
		<Card
			mode="outlined"
			style={{
				borderColor: theme.colors.surfaceVariant,
				borderRadius: theme.roundness,
			}}
		>
			<List.Accordion
				title={title}
				titleStyle={theme.fonts.labelLarge}
				expanded={expanded}
				onPress={() => setExpanded((previous) => !previous)}
				style={{
					paddingVertical: 0,
					backgroundColor: expanded
						? theme.colors.elevation.level1
						: theme.colors.surface,
				}}
			>
				{levels.map((level, index) => (
					<Box key={level.id}>
						{index === 0 ? <Divider /> : null}
						<LevelDetailBlock level={level} />
						{index === levels.length - 1 ? null : <Divider />}
					</Box>
				))}
			</List.Accordion>
		</Card>
	);
};
